import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote: 'Houzzdat made our procurement process seamless and reliable!',
    name: 'Amit S.',
    company: 'Skyline Developers',
  },
  {
    quote: 'Transparent pricing and timely delivery every time.',
    name: 'Priya R.',
    company: 'UrbanBuild Co.',
  },
  {
    quote: 'Access to credit helped us scale projects faster.',
    name: 'Rahul M.',
    company: 'Metro Estates',
  },
];

const Testimonials = () => (
  <motion.section
    className="max-w-5xl mx-auto py-10 md:py-16 px-2 md:px-4"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <h2 className="text-xl md:text-2xl font-bold text-center text-primary mb-8 md:mb-10">What Our Clients Say</h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
      {testimonials.map((t, i) => (
        <div key={i} className="bg-white rounded-xl shadow-soft p-4 md:p-6 flex flex-col items-center">
          <p className="text-primary italic mb-4 text-sm md:text-base">“{t.quote}”</p>
          <div className="text-accent font-semibold text-sm md:text-base">{t.name}</div>
          <div className="text-xs md:text-sm text-gray-500">{t.company}</div>
        </div>
      ))}
    </div>
  </motion.section>
);

export default Testimonials; 